import { useMemo } from "react";
import { useHabilidadesListaViewModel } from "../../viewModels/habilidades_lista_view_model";
import { GenerateHabilidadesListaColumns } from "./columns";
import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Habilidade } from "../../../domain/models/habilidade";
import { CadastroHabilidadeModal } from "./components/cadastro_habilidade_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";

/**
 * HabilidadesLista
 */

export const HabilidadesLista = () => {
  const viewModel = useHabilidadesListaViewModel();

  const columnsDef = useMemo(() => {
    return GenerateHabilidadesListaColumns({
      onActionEdit: viewModel.handleHabilidadeCadastroOpenState,
      onActionDelete: viewModel.handleHabilidadeDeleteOpenState,
    });
  }, [
    viewModel.handleHabilidadeCadastroOpenState,
    viewModel.handleHabilidadeDeleteOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="w-[160px] ">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={() => viewModel.handleHabilidadeCadastroOpenState(null, true)}>
                Nova Habilidade
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Habilidades
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Habilidade</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  tipoPesquisa={viewModel.filters.tipoPesquisa}
                  valueField={viewModel.filters.valueField}
                  status={viewModel.filters.status}
                  onTipoPesquisaChange={viewModel.handleTipoPesquisaChange}
                  onValueFieldChange={viewModel.handleValueFieldChange} />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="habilidades_lista"
                    getRowHeight={() => 'auto'}
                    disableRowSelectionOnClick={true}
                    disableColumnMenu={false}
                    getRowId={(row: Habilidade) => row.idHabilidade}
                    columns={columnsDef}
                    loading={viewModel.loading}
                    rows={viewModel.habilidades}
                    rowCount={viewModel.habilidades.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }} />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }

        <CadastroHabilidadeModal
          open={viewModel.openCadastroModal}
          saving={viewModel.saving}
          selectedHabilidade={viewModel.selectedHabilidade ?? null}
          onSubmit={viewModel.handleSubmit}
          onOpenChangeHistory={viewModel.handleOpenChangeHistory}
          onClose={() => viewModel.handleHabilidadeCadastroOpenState(null, false)} />

        <DeleteDialog
          open={viewModel.openDeleteModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleHabilidadeDeleteOpenState(null, false)}
          title={`Você realmente deseja excluir este item?`}
          onDelete={viewModel.handleConfirmarDeletarHabilidade} />

        {/**
          * Modal historico de alterações.
          */}

        <ChangeHistoryModal
          changeHistoryHandler={viewModel.changeHistory} />

      </div>
    </>
  );
}